export default __webpack_public_path__ + "static/wave-right-0262a99abd557656099f9e029c936977.png";